import { Injectable } from '@angular/core'
import { MbProductTabResourcesAdapter } from './mb-product-tab-resources.adapter'

@Injectable({
  providedIn: 'root',
})
export class MbProductTabResourcesConnector {

  constructor (protected adapter: MbProductTabResourcesAdapter) {
  }

  get (productCode: string, maxCount?: number) {
    return this.adapter.load(productCode, maxCount)
  }
}
